import { useState, KeyboardEvent, useEffect } from "react";
import { css } from "@linaria/core";
import Button from "../button";
import Banner from "../Banner";
import { COOKIE_CONSENT_NAME, COOKIE_CONSENT_VALUE } from "../../constants";
import { useCookieValue, useAnalyticsEnabled } from "../../utils";
import Link from "next/link";
const CTAButton = "clh8ud0"; // eslint-disable-next-line no-unused-vars

let storedSetShown: ((shown: boolean) => void) | undefined;
export function showBanner(): void {
  if (storedSetShown === undefined) {
    return;
  }

  storedSetShown(true);
}

function CookieBanner(): JSX.Element {
  const {
    setValue
  } = useCookieValue(COOKIE_CONSENT_NAME);
  const enabled = useAnalyticsEnabled();
  const [shown, setShown] = useState(false);
  storedSetShown = setShown;
  useEffect(() => {
    setShown(enabled);
  }, [enabled]);
  useEffect(() => {
    setShown(!enabled);
  }, [setShown, enabled]);

  function accept() {
    setValue(COOKIE_CONSENT_VALUE);
    setShown(false);
  }

  function handleKeyDown(event: KeyboardEvent<HTMLButtonElement>) {
    const {
      key
    } = event;

    if (key === "Enter" || key === " ") {
      event.preventDefault();
      accept();
    }
  }

  function hide() {
    setShown(false);
  }

  return <>
      {shown && <Banner hide={hide}>
          <p>
            We use cookies to analyze site performance and deliver personalized
            content. By clicking “Agree”, you consent to our{" "}
            <Link href="/privacy" passHref>
              <a>Cookie Policy</a>
            </Link>
            . You may change your settings at any time.
          </p>
          <Button className={CTAButton} onClick={accept} onKeyDown={handleKeyDown} buttonStyle="primary">
            Agree
          </Button>
        </Banner>}
    </>;
}

export default CookieBanner;

require("../../../.linaria-cache/src/components/cookieBanner/index.linaria.module.css");